<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color ps-2">{{title}}</h1>
    </div>
    <div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden">
        <div class="row">
            <div class="col px-4">
                <label for="'vendor'" class="text-primary-color mb-0 secondary-text">{{data?.OEMExcessPopup?'Customer':'Vendor'}}</label>
            </div>
        </div>
        <div class="row py-4">
            <div class="col-12 col-md-9 px-3">
             <div class="row row-gap-3">
                <div class="col-12 col-sm-6 col-md-4 px-3">
                    <app-dropdown
                    [selectLabel]="data?.OEMExcessPopup?'Customer':'Vendor'"
                    [data]="data?.OEMExcessPopup ? getAllDropdown?.customerCompanyNameList : getAllDropdown?.vendorNameList"
                    [selectValue]="data?.OEMExcessPopup ? formModel?.companyId : formModel?.vendorId"
                    (selectValueEmit)="data?.OEMExcessPopup ? (formModel.companyId = $event) : formModel.vendorId = $event;getContactList($event)"
                    [required]="true"
                  >
                  </app-dropdown>
                </div>
                <div class="col-12 col-sm-6 col-md-4 px-3">
                    <app-dropdown
                    [selectLabel]="'Contact'"
                    [data]="data?.OEMExcessPopup ? getAllDropdown?.contactNameList : getAllDropdown?.vendorContactList"
                    [selectValue]="data?.OEMExcessPopup ? formModel.contactId : formModel?.vendorContactId"
                    (selectValueEmit)="data?.OEMExcessPopup ? formModel.contactId = $event:formModel.vendorContactId = $event"
                    [required]="false"
                  >
                  </app-dropdown>
                </div>
                <div class="col-12 col-sm-6 col-md-4 px-3">
                    <app-date-picker 
                    [time]="false"
                    [inputLabel]="'Expiration Date'"
                    [inputValue]="formModel?.expirationDate"
                    (inputValueEmit)="formModel.expirationDate = $event">
                   </app-date-picker>
               
                </div>
             </div>
            </div>
            <!-- <div class="col-3 pb-4 px-3">
            </div> -->
        </div>
    
        <div class="row">
            <div class="col px-4">
                <label for="'vendor'" class="text-primary-color mb-0 secondary-text">Part Details</label>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-12 col-sm-4 col-md-3 px-3 d-flex justify-content-end">
                <label for="'add-part'" class="text-semi-primary hand mb-0 font-14" (click)="openAddEditPartModal()">+ Add Part
                </label>
            </div>
        </div>
    
        <div class="row">
            <div class="col-12 col-md-9 mb-4 mb-md-0 px-3">
                <div class="row row-gap-3">
                    <div class="col-12 col-sm-4 px-3">
                      <app-dropdown
                        [selectLabel]="'MPN'"
                        [data]="getAllDropdown?.mpnList | dependentFilter : formModel?.mpnId : formModel?.mfrId : 'mpn': getAllDropdown?.mpnList"
                        [selectValue]="formModel?.mpnId"
                        (selectValueEmit)="selectMpnMfrValueChange($event, 'mpn')"
                        [required]="true"
                      >
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-4 px-3">
                        <app-input onlyNumbers
                        [inputLabel]="'Quantity'" 
                        [inputType]="'text'" 
                        [inputValue]="formModel?.qty"
                        (inputValueEmit)="formModel.qty = $event === '' ? 0 : $event"
                        (parentFun)="onKeydown($event, '#description')"
                        >
                        </app-input>
                    </div>
                    <div class="col-12 col-sm-4 px-3">
                      <app-multiselect-dropdown
                      [listLabel]="'COO'"
                      [list]="getAllDropdown?.countryList"
                      [checkedList]="filterCheckList?.coo_CheckList"
                      (inputValueEmit)="inputValueCOOEmit($event)"
                    >
                    </app-multiselect-dropdown>
                    </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12 col-sm-4 px-3 d-flex justify-content-end">
                            <label for="'add-part'" class="text-semi-primary hand mb-0 font-14" (click)="openAddEditMFRModal()">+ Add MFR
                            </label>
                        </div>
                    </div>
                    <div class="row row-gap-3">
                        <div class="col-12 col-sm-4 px-3">
                            <app-dropdown
                            [selectLabel]="'MFR'"
                            [data]="getAllDropdown?.masterManufacturerWithChildrenList | dependentFilter : formModel?.mpnId : formModel?.mfrId : 'mfr' : getAllDropdown?.mpnList"
                            [selectValue]="formModel?.mfrId"
                            (selectValueEmit)="selectMpnMfrValueChange($event, 'mfr')"
                            [required]="true"
                          >
                          </app-dropdown>
                        </div>
                        <div class="col-12 col-sm-4 px-3">
                            <app-input 
                            [inputLabel]="'Unit Cost'" 
                            [inputType]="'text'" 
                            [inputValue]="formModel?.unitCost"
                            (inputValueEmit)="formModel.unitCost =$event;"
                            (parentFun)="onKeydown($event, '#description')"
                            >
                            </app-input>
                        </div>
                        <div class="col-12 col-sm-4 px-3">
                            <app-input 
                            [inputLabel]="'Date Code'" 
                            [inputType]="'text'" 
                            [inputValue]="formModel?.dateCode"
                            (inputValueEmit)="formModel.dateCode =$event;"
                            (parentFun)="onKeydown($event, '#description')"
                            >
                            </app-input>
                        </div>
                        </div>
    
                <div class="row row-gap-3 py-4">
                    <div class="col-12 col-sm-4 px-3">
                        <app-input 
                        [inputLabel]="data?.OEMExcessPopup?'CPN':'VPN'" 
                        [inputType]="'text'" 
                        [inputValue]="data?.OEMExcessPopup ?formModel?.cpn:formModel?.vpn"
                        (inputValueEmit)="data?.OEMExcessPopup ? (formModel.cpn = $event) : formModel.vpn =$event;"
                        (parentFun)="onKeydown($event, '#description')"
                        >
                        </app-input>

                    </div>
                    <div class="col-12 col-sm-4 px-3">
                      <app-multiselect-dropdown
                      [listLabel]="'RoHS'"
                      [list]="getAllDropdown?.roHSList"
                      [checkedList]="filterCheckList?.rohs_CheckList"
                      (inputValueEmit)="inputValueEmit($event)"
                    >
                    </app-multiselect-dropdown>

                    </div>
                    <div class="col-12 col-sm-4 px-3">
                        <app-input 
                        [inputLabel]="'Lot Code'" 
                        [inputType]="'text'" 
                        [inputValue]="formModel?.lotCode"
                        (inputValueEmit)="formModel.lotCode =$event;"
                        (parentFun)="onKeydown($event, '#description')"
                        >
                        </app-input>
                    </div>
                </div>
                <div class="row row-gap-3">
                    <div class="col-12 col-sm-4 px-3">
                        <app-textarea 
                        [label]="'Description'" 
                        [name]="'description'"
                        [id]="'description'"
                        [isDisable]="true"
                        [inputValue]="formModel.description" 
                        (inputValueEmit)="formModel.description=$event"
                        [textareaHeight]="'11.46rem'">
                    </app-textarea>
                    </div>
                       <div class="col-12 col-sm-4 px-3">
                        <div class="pb-4">
                            <app-input 
                                [inputLabel]="'Standard Packaging'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.standardPackagingId"
                                (inputValueEmit)="formModel.standardPackagingId = $event"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                        </div>
                        <div class="pb-4">
                            <app-input 
                                [inputLabel]="'SPQ'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.spq"
                                (inputValueEmit)="formModel.spq =$event;"
                                (parentFun)="onKeydown($event, '#description')"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                          
                        </div>
                        <div>
                            <app-input 
                                [inputLabel]="'UoM'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.uomId"
                                (inputValueEmit)="formModel.uomId =$event;"
                                (parentFun)="onKeydown($event, '#description')"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                          
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 px-3">
                        <div class="pb-4">
                            <app-input 
                                [inputLabel]="'MOQ'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.moq"
                                (inputValueEmit)="formModel.moq =$event;"
                                (parentFun)="onKeydown($event, '#description')"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                        </div>
                        <div class="pb-4">
                            <app-input 
                                [inputLabel]="'Mount Type'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.mountTypeId"
                                (inputValueEmit)="formModel.mountTypeId =$event;"
                                (parentFun)="onKeydown($event, '#description')"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                          
                        </div>
                        <div>
                            <app-input 
                                [inputLabel]="'Temp Grade'" 
                                [inputType]="'text'" 
                                [inputValue]="formModel?.tempGradeId"
                                (inputValueEmit)="formModel.tempGradeId =$event;"
                                (parentFun)="onKeydown($event, '#description')"
                                [isInputDisabled]="true"
                            >
                            </app-input>
                            <!-- <app-dropdown
                             [selectLabel]="'Temp Grade'"
                             [data]="getAllDropdown?.temperatureGradeList"
                             [selectValue]="formModel?.tempGradeId"
                             (selectValueEmit)="formModel.tempGradeId = $event"
                             [required]="false"
                             >
                            </app-dropdown> -->
                        </div>

                    </div>
                </div>
    
            </div>
            <div class="col-12 col-md-3 px-3">
                <app-textarea 
                [label]="'Line Notes (Max 300 characters)'"
                [textareaHeight]="'clamp(5rem, 42vw, 24.5rem)'"
                [name]="'notes'"
                [id]="'notes'"
                [maxlength]="300"
                [inputValue]="formModel?.notes"
                (inputValueEmit)="formModel.notes=$event"
                ></app-textarea>
            </div>
    
        </div>
    
    </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex gap-3">
            <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
                class="" (click)="activeModal.close({title,confirm:false})"
                [buttonLable]="enumButtonName.CANCEL"></app-button>
                <app-button  [buttonType]="'button'" [button_2]="true"
                [buttonClass]=" (data?.OEMExcessPopup ? formModel?.companyId : formModel?.vendorId) && formModel?.mpnId && formModel?.mfrId ? 'button-primary button popup-button' : 'button-info button popup-button cursor-notAllowed'"
                class="" [buttonLable]="formModel?.id? 'Update Part' : 'Add Part'"
                (click)=" (data?.OEMExcessPopup ? formModel?.companyId : formModel?.vendorId) && formModel?.mpnId && formModel?.mfrId ? addParts():''"></app-button>
        </div>
    </div>
</div>